var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',_vm._g(_vm._b({},'v-radio-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(option){return _c('v-radio',{key:option.value,attrs:{"value":option.value,"label":option.text}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }